import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  FaUser,
  FaMapMarkerAlt,
  FaBriefcase,
  FaGraduationCap,
  FaUniversity,
  FaEnvelope,
  FaGlobe,
  FaTools,
  FaStar,
  FaTextHeight,
  FaUpload,
  FaTimes,
  FaLock,
  FaEye,
  FaEyeSlash,
  FaFile,
  FaToggleOn,
  FaToggleOff,
} from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SummaryApi from "../common/index";
import ReactQuill from "react-quill";
import MultiSelectDropdown from "./MultiSelectDropdown"; // Import the new component

const EditInstructorForm = () => {
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    alternate_mobile_number: "",
      mobile_number: "",
    address: "",
    job_title: "",
    total_experience: "",
    qualification: "",
    study_university: "",
    email: "",
    website: "",
    skills: "",
    rating: "",
    description: "",
    about_instructor1: "",
    about_instructor2: "",
    instructor_image: null,
    document1: null,
    document2: null,
    document3: null,
    document4: null,
    document5: null,
    password: "",
     is_self_registered: 0,
    is_active: 0,
    instructor_id: "",
    selectedCategories: [], // To store an array of selected category IDs
    selectedCourses: [], // To store an array of selected course IDs
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [documentPreviews, setDocumentPreviews] = useState({
    document1: null,
    document2: null,
    document3: null,
    document4: null,
    document5: null,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [hasError, setHasError] = useState({
    first_name: false,
    last_name: false,
     mobile_number: false,
    email: false,
    selectedCategories: false, // For validation feedback
    selectedCourses: false, // For validation feedback
  });
  const [errorMessage, setErrorMessage] = useState("");
  const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setIsLoading] = useState(true); // Add loading state for data fetching
  const [isActiveStatus, setIsActiveStatus] = useState(false);
  const [isLoadingCategories, setIsLoadingCategories] = useState(true);
  const [activeCategories, setActiveCategories] = useState([]);
  const [allActiveCourses, setAllActiveCourses] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [availableCoursesForSelection, setAvailableCoursesForSelection] =
    useState([]);

  // NEW STATE FOR DISPLAYING ASSOCIATED CATEGORY/COURSE NAMES from getCourseIdByInstructorId API
  const [associatedCategoriesDisplay, setAssociatedCategoriesDisplay] =
    useState([]);
  const [associatedCoursesDisplay, setAssociatedCoursesDisplay] = useState([]);
  const [associatedCourseIds, setAssociatedCourseIds] = useState([]);
  // Fixed: use state instead of ref so the effect triggers reliably
  const [fetchedInstructorData, setFetchedInstructorData] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();

  // Fixed: define isDarkMode (you already pass it to MultiSelectDropdown)
  const isDarkMode = document.documentElement.classList.contains("dark");

  const formatImageUrl = (imagePath) => {
    if (!imagePath) return "";
    if (imagePath.startsWith("http")) {
      return imagePath;
    }
    const baseUrl = SummaryApi.Images.url.replace("/api", "");
    if (imagePath.includes(baseUrl)) {
      return imagePath;
    }
    if (imagePath.startsWith("uploads/")) {
      return `${baseUrl}/${imagePath}`;
    }
    return `${baseUrl}/${imagePath}`;
  };

  const isImage = (path) => {
    if (!path) return false;
    const ext =
      typeof path === "string"
        ? path.split(".").pop().toLowerCase()
        : path.name?.split(".").pop().toLowerCase();
    return ["jpg", "jpeg", "png", "gif", "bmp", "svg", "webp"].includes(ext);
  };

  // 1. Fetch Categories on Mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(SummaryApi.getActiveCategories.url, {
          method: SummaryApi.getActiveCategories.method,
        });
        const data = await res.json();
        if (data.status) setActiveCategories(data.data);
        else toast.error(data.message || "Failed to fetch categories");
      } catch (err) {
        console.error(err);
        toast.error("Error fetching categories");
      } finally {
        setIsLoadingCategories(false);
      }
    };
    fetchCategories();
  }, []);
useEffect(() => {
  const fetchCourses = async () => {
    if (formData.selectedCategories.length === 0) {
      setAllActiveCourses([]);
      setAvailableCoursesForSelection([]);
      setFormData((p) => ({ ...p, selectedCourses: [] }));
      return;
    }

    try {
      const res = await fetch(SummaryApi.getActiveCoursesBycategory.url, {
        method: SummaryApi.getActiveCoursesBycategory.method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          category_ids: formData.selectedCategories,
        }),
      });
      const data = await res.json();

      if (data.status) {
        const courses = data.data || [];
        setAllActiveCourses(courses);
        
        // Filter out courses that are already associated with the instructor
        const filteredCourses = courses.filter(course => 
          !associatedCourseIds.includes(String(course.course_id))
        );
        
        setAvailableCoursesForSelection(filteredCourses);

        const validIds = courses.map((c) => String(c.course_id));
        setFormData((p) => ({
          ...p,
          selectedCourses: p.selectedCourses.filter((id) => validIds.includes(id)),
        }));
      } else {
        toast.error(data.message || "Failed to fetch courses");
        setAllActiveCourses([]);
        setAvailableCoursesForSelection([]);
        setFormData((p) => ({ ...p, selectedCourses: [] }));
      }
    } catch (err) {
      console.error(err);
      toast.error("Error fetching courses");
      setAllActiveCourses([]);
      setAvailableCoursesForSelection([]);
      setFormData((p) => ({ ...p, selectedCourses: [] }));
    }
  };

  fetchCourses();
}, [formData.selectedCategories, associatedCourseIds]);
useEffect(() => {
  const urlParams = new URLSearchParams(location.search);
  const encodedId = urlParams.get("id");

  if (encodedId) {
    try {
      const decodedId = atob(encodedId);
      setIsLoading(true);
      setFormData((prev) => ({ ...prev, instructor_id: decodedId }));

      const getInstructorDetails = async (id) => {
        try {
          const response = await fetch(SummaryApi.InstructorByid.url, {
            method: SummaryApi.InstructorByid.method,
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ instructor_id: id }),
          });
          const data = await response.json();

          if (data.status) {
            const instructorData = data.data;
            
            // Check if instructor is inactive AND has documents
            const hasDocuments = [
              "document1",
              "document2", 
              "document3",
              "document4",
              "document5"
            ].some(doc => instructorData[doc] && instructorData[doc] !== "N/A");
            
            // Only redirect if instructor is inactive (is_active = 0) AND has documents
            if (instructorData.is_active === 0 && hasDocuments) {
              // Immediately navigate to access denied without showing the form
              navigate("/instructor-access-denied");
              return; // Stop further execution
            }
            
            // If active (is_active = 1) OR inactive with no documents, load the form
            setFetchedInstructorData(instructorData);
          } else {
            toast.error(data.message || "Failed to fetch instructor details");
            setFetchedInstructorData(null);
          }
        } catch (error) {
          console.error("Error fetching instructor details:", error);
          toast.error("Error fetching instructor details");
          setFetchedInstructorData(null);
        } finally {
          setIsLoading(false);
        }
      };
      getInstructorDetails(decodedId);
    } catch (error) {
      console.error("Invalid encoded ID:", error);
      toast.error("Invalid instructor ID");
      setIsLoading(false);
    }
  } else {
    toast.error("Instructor ID is required");
    setIsLoading(false);
  }
}, [location.search, navigate]);
  // Fetch associated courses/categories for display
  useEffect(() => {
    const fetchAssociatedCourseData = async () => {
      if (formData.instructor_id) {
        try {
          const response = await fetch(
            SummaryApi.getCourseIdByInstructorId.url,
            {
              method: SummaryApi.getCourseIdByInstructorId.method,
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ instructor_id: formData.instructor_id }),
            }
          );
          const data = await response.json();

          if (data.status) {
            const uniqueCategories = [
              ...new Set(data.data.map((item) => item.category_name)),
            ];
            const uniqueCourses = [
              ...new Set(data.data.map((item) => item.course_title)),
            ];
            const uniqueCourseIds = [
              ...new Set(data.data.map((item) => String(item.course_id))),
            ]; // NEW: Get course IDs
            
            setAssociatedCategoriesDisplay(uniqueCategories);
            setAssociatedCoursesDisplay(uniqueCourses);
            setAssociatedCourseIds(uniqueCourseIds); // NEW: Store associated course IDs
          } else {
            setAssociatedCategoriesDisplay([]);
            setAssociatedCoursesDisplay([]);
            setAssociatedCourseIds([]); // NEW
          }
        } catch (error) {
          console.error("Error fetching associated courses:", error);
          setAssociatedCategoriesDisplay([]);
          setAssociatedCoursesDisplay([]);
          setAssociatedCourseIds([]); // NEW
        }
      }
    };

    fetchAssociatedCourseData();
  }, [formData.instructor_id]);
  // 3. Populate form when both instructor data & categories are ready
  useEffect(() => {
    if (fetchedInstructorData && activeCategories.length > 0) {
      const instructor = fetchedInstructorData;

      const instructorCategories = instructor.category_id
        ? Array.isArray(instructor.category_id)
          ? instructor.category_id.map(String)
          : [String(instructor.category_id)]
        : [];

      const instructorCourses = instructor.course_id
        ? Array.isArray(instructor.course_id)
          ? instructor.course_id.map(String)
          : [String(instructor.course_id)]
        : [];

      setFormData((prev) => ({
        ...prev,
        ...instructor,
        instructor_id: prev.instructor_id || instructor.instructor_id,
        selectedCategories: instructorCategories,
        selectedCourses: instructorCourses,
      }));

      setIsActiveStatus(instructor.is_active === 1);

      if (instructor.instructor_image) {
        setImagePreview(formatImageUrl(instructor.instructor_image));
      }

      ["document1", "document2", "document3", "document4", "document5"].forEach((doc) => {
        if (instructor[doc]) {
          setDocumentPreviews((prev) => ({
            ...prev,
            [doc]: formatImageUrl(instructor[doc]),
          }));
        }
      });

      // Clear the fetched data so this effect doesn't run again unnecessarily
      setFetchedInstructorData(null);
    }
  }, [fetchedInstructorData, activeCategories]);

  // Fixed: cleanup blob URLs to prevent memory leaks
  useEffect(() => {
    return () => {
      if (imagePreview && imagePreview.startsWith("blob:")) {
        URL.revokeObjectURL(imagePreview);
      }
      Object.values(documentPreviews).forEach((url) => {
        if (url && url.startsWith("blob:")) {
          URL.revokeObjectURL(url);
        }
      });
    };
  }, [imagePreview, documentPreviews]);

  const handleCreateTimeslot = async (
    instructorId,
    categoryId,
    courseId
  ) => {
    if (!instructorId || !courseId) {
      console.error("Instructor ID and Course ID are required to create a timeslot.");
      return;
    }
    try {
      const response = await fetch(SummaryApi.createInstructorCourse.url, {
        method: SummaryApi.createInstructorCourse.method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          instructor_id: instructorId,
          course_id: courseId,
        }),
      });
      const data = await response.json();

      if (data.status) {
        // success
      } else {
        toast.error(
          data.message || `Failed to create timeslot for course ID ${courseId}`
        );
      }
    } catch (error) {
      console.error(`Error creating timeslot for course ID ${courseId}:`, error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "email") {
      return; // Email is disabled
    }
    setFormData({
      ...formData,
      [name]: value,
    });

    if (["first_name", "last_name"].includes(name)) {
      setHasError((prev) => ({
        ...prev,
        [name]: value.trim() === "",
      }));
    }
  };

  const handleCategorySelectionChange = (newSelection) => {
    setFormData((prev) => ({
      ...prev,
      selectedCategories: newSelection,
    }));
    setHasError((prev) => ({
      ...prev,
      selectedCategories: false,
    }));
  };

  const handleCourseSelectionChange = (newSelection) => {
    setFormData((prev) => ({
      ...prev,
      selectedCourses: newSelection,
    }));
    setHasError((prev) => ({
      ...prev,
      selectedCourses: false,
    }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    if (["first_name", "last_name", "mobile_number"].includes(name)) {
      setHasError((prev) => ({
        ...prev,
        [name]: value.trim() === "",
      }));
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file) {
      if (field === "instructor_image") {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImagePreview(reader.result);
          setFormData((prev) => ({
            ...prev,
            [field]: file,
          }));
        };
        reader.readAsDataURL(file);
      } else {
        setDocumentPreviews({
          ...documentPreviews,
          [field]: URL.createObjectURL(file),
        });
        setFormData((prev) => ({
          ...prev,
          [field]: file,
        }));
      }
    }
  };

  const removeFile = (field) => {
    if (field === "instructor_image") {
      setImagePreview(null);
      setFormData((prev) => ({
        ...prev,
        instructor_image: null,
      }));
    } else {
      setDocumentPreviews({
        ...documentPreviews,
        [field]: null,
      });
      setFormData((prev) => ({
        ...prev,
        [field]: null,
      }));
    }
  };

  const hasAnyDocument = () => {
    return [
      "document1",
      "document2",
      "document3",
      "document4",
      "document5",
    ].some((doc) => formData[doc] !== null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
if (!formData.instructor_id && formData.selectedCourses.length === 0) {
    toast.error("Please select at least 1 course");
    window.scrollTo({ top: 0, behavior: "smooth" });
    return;
  }
  
    const requiredProfileFields = ["first_name", "last_name", "mobile_number"];
    const newErrors = {};
    let hasValidationError = false;

    requiredProfileFields.forEach((field) => {
      if (
        !formData[field] ||
        (typeof formData[field] === "string" && !formData[field].trim())
      ) {
        newErrors[field] = true;
        hasValidationError = true;
      } else {
        newErrors[field] = false;
      }
    });

    if (
      formData.selectedCourses.length > 0 &&
      formData.selectedCategories.length === 0
    ) {
      newErrors.selectedCategories = true;
      hasValidationError = true;
      toast.error(
        "Please select at least one category if courses are selected."

      );
    }

    setHasError(newErrors);

    if (hasValidationError) {
      setErrorMessage("Please fix the errors in the form.");
      toast.error("Please fix the errors in the form.");
      return;
    }

    if (formData.is_active === 0 && !hasAnyDocument()) {
      toast.error(
        "Please upload at least one document when account is inactive to be processed."
      );
      return;
    }

    setIsSubmitting(true);
    setErrorMessage("");

    const submitData = new FormData();
    submitData.append("instructor_id", formData.instructor_id);
    submitData.append("first_name", formData.first_name || "N/A");
    submitData.append("last_name", formData.last_name || "N/A");
    submitData.append("mobile_number", formData.mobile_number || "N/A");
    submitData.append(
      "alternate_mobile_number",
      formData.alternate_mobile_number || "N/A"
    );
    submitData.append("address", formData.address || "N/A");
    submitData.append("job_title", formData.job_title || "N/A");
    submitData.append("total_experience", formData.total_experience || "N/A");
    submitData.append("qualification", formData.qualification || "N/A");
    submitData.append("study_university", formData.study_university || "N/A");
    submitData.append("email", formData.email || "N/A");
    submitData.append("website", formData.website || "N/A");
    submitData.append("skills", formData.skills || "N/A");
    submitData.append("rating", formData.rating || "N/A");
    submitData.append("description", formData.description || "N/A");
    submitData.append("about_instructor1", formData.about_instructor1 || "N/A");
    submitData.append("about_instructor2", formData.about_instructor2 || "N/A");
    submitData.append("is_active", formData.is_active || 0);
    submitData.append("is_self_registered", formData.is_self_registered || 0);

    submitData.append(
      "selected_categories",
      JSON.stringify(formData.selectedCategories)
    );
    submitData.append(
      "selected_courses",
      JSON.stringify(formData.selectedCourses)
    );

    if (formData.password) {
      submitData.append("password", formData.password);
    }

    if (formData.instructor_image instanceof File) {
      submitData.append("instructor_image", formData.instructor_image);
    } else if (formData.instructor_image) {
      submitData.append("instructor_image_name", formData.instructor_image);
    }

    ["document1", "document2", "document3", "document4", "document5"].forEach(
      (doc) => {
        if (formData[doc] instanceof File) {
          submitData.append(doc, formData[doc]);
        } else if (typeof formData[doc] === "string" && formData[doc] !== "N/A") {
          submitData.append(`${doc}_name`, formData[doc]);
        }
      }
    );

    try {
      const response = await fetch(SummaryApi.Instructorupdate.url, {
        method: SummaryApi.Instructorupdate.method,
        body: submitData,
      });
      const data = await response.json();

      if (data.status) {
        toast.success("Instructor profile updated successfully!");

        // Fixed: fire-and-forget timeslot creation (non-blocking)
        if (
          formData.instructor_id &&
          formData.selectedCategories.length > 0 &&
          formData.selectedCourses.length > 0
        ) {
          formData.selectedCourses.forEach(async (courseId) => {
            const course = allActiveCourses.find(
              (c) => String(c.course_id) === String(courseId)
            );
            if (
              course &&
              formData.selectedCategories.includes(String(course.category_id))
            ) {
              await handleCreateTimeslot(
                formData.instructor_id,
                String(course.category_id),
                courseId
              );
            }
          });
        }

        if (formData.is_active === 1) {
          setTimeout(() => {
            if (window.opener) {
              window.close();
            } else {
              window.history.back();
            }
          }, 300);
        } else {
          navigate("/instructor-access-denied");
        }
      } else {
        setErrorMessage(data.message || "Failed to update instructor");
        toast.error(data.message || "Failed to update instructor");
      }
    } catch (error) {
      console.error("Error:", error);
      setErrorMessage("Error updating instructor. Please try again.");
      toast.error("Error updating instructor");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="p-4 sm:p-6 bg-gray-50 dark:bg-gray-900 min-h-screen transition-colors duration-300">
      <div className="max-w-7xl mx-auto">
              {/* Show only loading spinner while checking documents */}
      {isLoading && (
        <div className="fixed inset-0 bg-white dark:bg-gray-900 bg-opacity-80 flex items-center justify-center z-50">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1f4774] dark:border-white mx-auto mb-4"></div>
            <p className="text-[#1f4774] dark:text-gray-300 font-medium">Checking instructor access...</p>
          </div>
        </div>
      )}
      
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-md p-5 sm:p-6 mb-6 sm:mb-8 border-2 border-gray-300 dark:border-gray-700 font-sans text-base">
          <h2 className="text-lg sm:text-xl font-semibold text-gray-800 dark:text-white mb-4">
            {!isActiveStatus ? "Submit Profile" : "Edit Instructor"}
          </h2>

          {isLoading && (
            <div className="fixed inset-0 bg-white dark:bg-gray-900 bg-opacity-80 flex items-center justify-center z-50">
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1f4774] dark:border-white mx-auto mb-4"></div>
                <p className="text-[#1f4774] dark:text-gray-300 font-medium">Loading instructor data...</p>
              </div>
            </div>
          )}

          {isSubmitting && (
            <div className="fixed inset-0 bg-white dark:bg-gray-900 bg-opacity-80 flex items-center justify-center z-50">
              <div className="text-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#1f4774] dark:border-white mx-auto mb-4"></div>
                <p className="text-[#1f4774] dark:text-gray-300 font-medium">
                  {!isActiveStatus ? "Saving instructor..." : "Updating instructor..."}
                </p>
              </div>
            </div>
          )}

          {errorMessage && (
            <div className="mb-4 p-3 bg-red-100 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-md border border-red-400 dark:border-red-700">
              {errorMessage}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className={isLoading ? "opacity-50 pointer-events-none" : ""}>
              {/* Profile Section */}
              <div className="mb-8">
                <h3 className="text-md font-semibold text-gray-700 dark:text-gray-200 mb-4 border-b pb-2 border-gray-300 dark:border-gray-600">
                  Profile Information
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {/* First Name */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      First Name <span className="text-red-500">*</span>
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <div className="relative">
                        <FaUser className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm" />
                        <input
                          type="text"
                          name="first_name"
                          value={formData.first_name}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`block w-full border rounded-md p-1.5 pl-8 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 ${hasError.first_name ? "border-red-500 dark:border-red-400" : ""}`}
                          required
                        />
                      </div>
                    )}
                    {hasError.first_name && (
                      <p className="text-red-500 dark:text-red-400 text-xs mt-1">
                        First Name is required.
                      </p>
                    )}
                  </div>

                  {/* Last Name */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Last Name <span className="text-red-500">*</span>
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <input
                        type="text"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`block w-full border rounded-md p-1.5 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 ${hasError.last_name ? "border-red-500 dark:border-red-400" : ""}`}
                        required
                      />
                    )}
                    {hasError.last_name && (
                      <p className="text-red-500 dark:text-red-400 text-xs mt-1">
                        Last Name is required.
                      </p>
                    )}
                  </div>

                  {/* Email */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Email <span className="text-red-500">*</span>
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <div className="relative">
                        <FaEnvelope className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm" />
                        <input
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          className={`block w-full border rounded-md p-1.5 pl-8 border-gray-300 dark:border-gray-600 bg-gray-100 dark:bg-gray-700 text-sm cursor-not-allowed text-gray-500 dark:text-gray-400 ${hasError.email ? "border-red-500 dark:border-red-400" : ""}`}
                          required
                          disabled
                        />
                      </div>
                    )}
                    {hasError.email && (
                      <p className="text-red-500 dark:text-red-400 text-xs mt-1">
                        Please enter a valid email address.
                      </p>
                    )}
                  </div>

                  {/* Password */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Password (Optional - leave blank to keep existing)
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <div className="relative">
                        <FaLock className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm" />
                        <input
                          type={showPassword ? "text" : "password"}
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          className="block w-full border rounded-md p-1.5 pl-8 pr-10 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                        />
                        <button
                          type="button"
                          className="absolute right-2 top-2.5 text-gray-400 dark:text-gray-500 hover:text-gray-600 dark:hover:text-gray-300 focus:outline-none"
                          onClick={togglePasswordVisibility}
                          aria-label={
                            showPassword ? "Hide password" : "Show password"
                          }
                        >
                          {showPassword ? (
                            <FaEyeSlash size={14} />
                          ) : (
                            <FaEye size={14} />
                          )}
                        </button>
                      </div>
                    )}
                  </div>

                  {/* Mobile Number */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Mobile Number <span className="text-red-500">*</span>
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <div className="relative">
                        <FaPhone className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm" />
                        <input
                          type="text"
                          name="mobile_number"
                          value={formData.mobile_number}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            if (value.length <= 10) {
                              setFormData({
                                ...formData,
                                mobile_number: value,
                              });
                            }
                          }}
                          onBlur={handleBlur}
                          maxLength="10"
                          className={`block w-full border rounded-md p-1.5 pl-8 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200 ${hasError.mobile_number ? "border-red-500 dark:border-red-400" : ""}`}
                          required
                        />
                      </div>
                    )}
                    {hasError.mobile_number && (
                      <p className="text-red-500 dark:text-red-400 text-xs mt-1">
                        Mobile Number is required.
                      </p>
                    )}
                  </div>

                  {/* Alternate Mobile Number */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Alternate Mobile Number
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <div className="relative">
                        <FaPhone className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm"/>
                        <input
                          type="text"
                          name="alternate_mobile_number"
                          value={formData.alternate_mobile_number}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, "");
                            if (value.length <= 10) {
                              setFormData({
                                ...formData,
                                alternate_mobile_number: value,
                              });
                            }
                          }}
                          maxLength="10"
                          className="block w-full border rounded-md p-1.5 pl-8 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="mb-8">
       <h3 className="text-md font-semibold text-gray-700 dark:text-gray-200 mb-4 border-b pb-2 border-gray-300 dark:border-gray-600">
   Assign Courses (for Timeslots)
 </h3>
                <p className="text-sm text-gray-600 dark:text-gray-400 mb-3">
                  Select one or more categories and courses to associate with this
                  instructor. A timeslot will be attempted for each selected course upon
                  saving.
                </p>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                  {/* CATEGORY DROPDOWN */}
                  <div>
    <MultiSelectDropdown
  label="Categories"
  options={activeCategories.map((cat) => ({
    value: String(cat.category_id),
    label: cat.category_name,
  }))}
  selectedValues={formData.selectedCategories}
  onSelectionChange={handleCategorySelectionChange}
  placeholder="Select categories..."
  hasError={hasError.selectedCategories}
  errorMessage={
    hasError.selectedCategories
      ? "(Required if courses are selected)"
      : ""
  }
  isLoading={isLoadingCategories}
  loadingText="Loading categories..."
  isDarkMode={isDarkMode} // Make sure this is passed correctly
/>

                    {associatedCategoriesDisplay.length > 0 && (
                      <div className="mt-2 text-sm text-gray-700 dark:text-gray-300">
                        <span className="font-semibold mr-1">
                          Currently Associated Categories:
                        </span>
                        <div className="flex flex-wrap gap-2 mt-1">
                          {associatedCategoriesDisplay.map((catName, i) => (
                            <span
                              key={i}
                              className="bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 px-2 py-1 rounded-full text-[12px]"
                            >
                              {catName}
                            </span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* COURSE DROPDOWN */}
              <div>
          <MultiSelectDropdown
            label="Courses"
            options={availableCoursesForSelection.map((course) => ({
              value: String(course.course_id),
              label: course.course_title,
            }))}
            selectedValues={formData.selectedCourses}
            onSelectionChange={handleCourseSelectionChange}
            placeholder={
              formData.selectedCategories.length > 0
                ? "Select courses..."
                : "Select categories first to see available courses."
            }
            hasError={hasError.selectedCourses}
            errorMessage={
              hasError.selectedCourses
                ? "(Required if categories are selected for timeslots)"
                : ""
            }
            disabled={formData.selectedCategories.length === 0}
            isLoading={
              formData.selectedCategories.length > 0 &&
              allActiveCourses.length === 0
            }
            loadingText="Loading courses..."
            isDarkMode={isDarkMode}
          />

          {associatedCoursesDisplay.length > 0 && (
            <div className="mt-2 text-sm text-gray-700 dark:text-gray-300">
              <span className="font-semibold mr-1">
                Currently Associated Courses (not shown in dropdown):
              </span>
              <div className="flex flex-wrap gap-2 mt-1">
                {associatedCoursesDisplay.map((courseName, i) => (
                  <span
                    key={i}
                    className="bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 px-2 py-1 rounded-full text-[12px]"
                  >
                    {courseName}
                  </span>
                ))}
              </div>
            </div>
          )}
        </div>
                </div>
              </div>

              {/* Professional Section */}
              <div className="mb-8">
                <h3 className="text-md font-semibold text-gray-700 dark:text-gray-200 mb-4 border-b pb-2 border-gray-300 dark:border-gray-600">
                  Professional Information
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {/* Job Title */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Job Title
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <div className="relative">
                        <FaBriefcase className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm" />
                        <input
                          type="text"
                          name="job_title"
                          value={formData.job_title}
                          onChange={handleChange}
                          className="block w-full border rounded-md p-1.5 pl-8 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                        />
                      </div>
                    )}
                  </div>

                  {/* Total Experience */}
       <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Total Experience
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <input
                        type="number"
                        name="total_experience"
                        value={formData.total_experience}
                        onChange={handleChange}
                        className="block w-full border rounded-md p-1.5 border-gray-300 dark:border-gray-600 focus:border-[#1F4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1F4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                      />
                    )}
                  </div>

                  {/* Qualification */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Qualification
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <div className="relative">
                        <FaGraduationCap className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm" />
                        <input
                          type="text"
                          name="qualification"
                          value={formData.qualification}
                          onChange={handleChange}
                          className="block w-full border rounded-md p-1.5 pl-8 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                        />
                      </div>
                    )}
                  </div>

                  {/* Study University */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Study University
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <div className="relative">
                        <FaUniversity className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm" />
                        <input
                          type="text"
                          name="study_university"
                          value={formData.study_university}
                          onChange={handleChange}
                          className="block w-full border rounded-md p-1.5 pl-8 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                        />
                      </div>
                    )}
                  </div>

                  {/* Website */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Website
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <div className="relative">
                        <FaGlobe className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm" />
                        <input
                          type="text"
                          name="website"
                          value={formData.website}
                          onChange={handleChange}
                          className="block w-full border rounded-md p-1.5 pl-8 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                        />
                      </div>
                    )}
                  </div>

                  {/* Rating */}
                  <div className="relative">
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Rating
                    </label>
                    {isLoading ? (
                      <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <div className="relative">
                        <FaStar className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm" />
                        <input
                          type="number"
                          name="rating"
                          value={formData.rating}
                          onChange={handleChange}
                          className="block w-full border rounded-md p-1.5 pl-8 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                          step="0.1"
                          min="0"
                          max="5"
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              {/* About Section */}
              <div className="mb-8">
                <h3 className="text-md font-semibold text-gray-700 dark:text-gray-200 mb-4 border-b pb-2 border-gray-300 dark:border-gray-600">
                  About Instructor
                </h3>
                <div className="grid grid-cols-1 gap-4">
                  {/* Description */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Description
                    </label>
                    {isLoading ? (
                      <div className="h-24 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : (
                      <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        rows="3"
                        className="block w-full border rounded-md p-1.5 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                      />
                    )}
                  </div>

                  {/* About Instructors Row */}
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    {/* About Instructor 1 */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        About Instructor 1
                      </label>
                      {isLoading ? (
                        <div className="h-24 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                      ) : (
                        <textarea
                          name="about_instructor1"
                          value={formData.about_instructor1}
                          onChange={handleChange}
                          rows="3"
                          className="block w-full border rounded-md p-1.5 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                        />
                      )}
                    </div>

                    {/* About Instructor 2 */}
                    <div>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        About Instructor 2
                      </label>
                      {isLoading ? (
                        <div className="h-24 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                      ) : (
                        <textarea
                          name="about_instructor2"
                          value={formData.about_instructor2}
                          onChange={handleChange}
                          rows="3"
                          className="block w-full border rounded-md p-1.5 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mb-8">
                {/* Address */}
                <div className="relative">
                  <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                    Address
                  </label>
                  {isLoading ? (
                    <div className="h-28 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                  ) : (
                    <div className="relative">
                      <FaMapMarkerAlt className="absolute left-2 top-2.5 text-[#1f4774] dark:text-gray-400 text-sm" />
                      <textarea
                        name="address"
                        value={formData.address}
                        onChange={handleChange}
                        className="block w-full border rounded-md p-1.5 pl-8 border-gray-300 dark:border-gray-600 focus:border-[#1f4774] dark:focus:border-cyan-400 focus:ring-2 focus:ring-[#1f4774] dark:focus:ring-cyan-400 text-sm h-28 bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-200"
                        rows="4"
                      />
                    </div>
                  )}
                </div>

{/* Skills - PERFECT Dark Mode (Dropdowns Fixed!) */}

{/* Skills - PERFECT Dark Mode with White Icons */}
<div className="relative lg:col-span-1">
  <label className={`block text-sm font-medium mb-1 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
    Skills
  </label>

  <div className="relative">
    <ReactQuill
      theme="snow"
      value={formData.skills}
      onChange={(value) => setFormData(prev => ({ ...prev, skills: value }))}
      placeholder="Enter your skills..."
      modules={{
        toolbar: [
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          ["clean"],
        ],
      }}
      className={`
        h-26 rounded-md text-sm overflow-hidden
        /* Base container */
        [&_.ql-container]:min-h-[96px]
        [&_.ql-container]:bg-white dark:[&_.ql-container]:bg-gray-700
        [&_.ql-container]:border-gray-300 dark:[&_.ql-container]:border-gray-600
        
        /* Editor text color */
        [&_.ql-editor]:text-gray-900 dark:[&_.ql-editor]:text-white
        [&_.ql-editor]:before:text-gray-500 dark:[&_.ql-editor]:before:text-gray-400
        
        /* Toolbar styling */
        [&_.ql-toolbar]:bg-gray-50 dark:[&_.ql-toolbar]:bg-gray-700
        [&_.ql-toolbar]:border-gray-300 dark:[&_.ql-toolbar]:border-gray-600

        /* Default icon colors */
        [&_.ql-stroke]:stroke-gray-700 dark:[&_.ql-stroke]:stroke-white
        [&_.ql-fill]:fill-gray-700 dark:[&_.ql-fill]:fill-white

        /* Picker labels (font size, etc.) */
        [&_.ql-picker-label]:text-gray-700 dark:[&_.ql-picker-label]:text-white

        /* Hover & Active States - BLUE in both themes */
        [&_.ql-toolbar_button:hover_.ql-stroke]:!stroke-[#3B82F6]
        [&_.ql-toolbar_button:hover_.ql-fill]:!fill-[#3B82F6]
        [&_.ql-toolbar_.ql-active_.ql-stroke]:!stroke-[#3B82F6]
        [&_.ql-toolbar_.ql-active_.ql-fill]:!fill-[#3B82F6]

        [&_.ql-toolbar_button:hover]:bg-blue-100 dark:[&_.ql-toolbar_button:hover]:bg-blue-900/40
        [&_.ql-toolbar_.ql-active]:bg-blue-100 dark:[&_.ql-toolbar_.ql-active]:bg-blue-900/40

        [&_.ql-picker-label:hover]:bg-blue-100 dark:[&_.ql-picker-label:hover]:bg-blue-900/40
        [&_.ql-picker-item:hover]:bg-blue-100 dark:[&_.ql-picker-item:hover]:bg-blue-900/40

        /* Dropdown menu */
        [&_.ql-picker-options]:bg-white dark:[&_.ql-picker-options]:bg-gray-800
        [&_.ql-picker-options]:border-gray-300 dark:[&_.ql-picker-options]:border-gray-600
        [&_.ql-picker-item]:text-gray-800 dark:[&_.ql-picker-item]:text-gray-200
      `}
    />
  </div>
</div>
</div>

              {/* Image Section */}
              <div className="mb-8">
                <h3 className="text-md font-semibold text-gray-700 dark:text-gray-200 mb-4 border-b pb-2 border-gray-300 dark:border-gray-600">
                  Profile Image
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {/* Instructor Image */}
                  <div>
                    <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                      Instructor Image
                    </label>
                    {isLoading ? (
                      <div className="h-16 w-16 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                    ) : imagePreview || formData.instructor_image ? (
                      <div className="relative mt-1">
                        <label className="cursor-pointer">
                          <img
                            src={
                              imagePreview ||
                              formatImageUrl(formData.instructor_image)
                            }
                            alt="Preview"
                            className="h-16 w-16 object-cover rounded-md border border-gray-300 dark:border-gray-600"
                          />
                          <input
                            type="file"
                            className="hidden"
                            onChange={(e) =>
                              handleFileChange(e, "instructor_image")
                            }
                            accept="image/*"
                          />
                        </label>
                      </div>
                    ) : (
                      <label className="flex flex-col items-center justify-center w-40 h-16 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md cursor-pointer hover:border-[#1f4774] dark:hover:border-cyan-400 bg-white dark:bg-gray-800">
                        <div className="flex flex-col items-center justify-center pt-3 pb-4">
                          <FaUpload className="w-6 h-6 mb-2 text-gray-400 dark:text-gray-500" />
                          <p className="mb-1 text-xs text-gray-500 dark:text-gray-400">
                            Click to upload
                          </p>
                        </div>
                        <input
                          type="file"
                          className="hidden"
                          onChange={(e) =>
                            handleFileChange(e, "instructor_image")
                          }
                          accept="image/*"
                        />
                      </label>
                    )}
                  </div>
                </div>
              </div>

              {/* Documents Section */}
              <div className="mb-8">
                <h3 className="text-md font-semibold text-gray-700 dark:text-gray-200 mb-4 border-b pb-2 border-gray-300 dark:border-gray-600 flex items-center justify-between">
                  Documents
                  {isActiveStatus && (
                    <span className="text-sm text-red-600 bg-red-100 dark:bg-red-900/30 px-2 py-1 rounded">
                      Upload Disabled (View Only - Instructor Active)
                    </span>
                  )}
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                  {[
                    "document1",
                    "document2",
                    "document3",
                    "document4",
                    "document5",
                  ].map((doc) => (
                    <div key={doc}>
                      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                        {doc.charAt(0).toUpperCase() + doc.slice(1)}
                        {isActiveStatus && (
                          <span className="text-xs text-gray-500 dark:text-gray-400 ml-1">
                            (View Only)
                          </span>
                        )}
                      </label>
                      {isLoading ? (
                        <div className="h-16 w-16 bg-gray-200 dark:bg-gray-700 rounded-md animate-pulse"></div>
                      ) : documentPreviews[doc] || formData[doc] ? (
                        <div className="relative mt-1">
                          {isActiveStatus ? (
                            <>
                              {(formData[doc] instanceof File &&
                                formData[doc].type.includes("image/")) ||
                              isImage(documentPreviews[doc] || formData[doc]) ? (
                                <img
                                  src={
                                    documentPreviews[doc] ||
                                    formatImageUrl(formData[doc])
                                  }
                                  alt={`${doc} Preview`}
                                  className="h-16 w-16 object-cover rounded-md cursor-pointer hover:opacity-80 border border-gray-300 dark:border-gray-600"
                                  onClick={() =>
                                    window.open(
                                      documentPreviews[doc] ||
                                        formatImageUrl(formData[doc]),
                                      "_blank"
                                    )
                                  }
                                />
                              ) : (
                                <div
                                  className="h-16 w-16 flex items-center justify-center bg-gray-100 dark:bg-gray-700 rounded-md cursor-pointer hover:bg-gray-200 dark:hover:bg-gray-600 border border-gray-300 dark:border-gray-600"
                                  onClick={() =>
                                    window.open(
                                      formatImageUrl(formData[doc]),
                                      "_blank"
                                    )
                                  }
                                >
                                  <FaFile className="text-2xl text-gray-400 dark:text-gray-500" />
                                </div>
                              )}
                            </>
                          ) : (
                            <>
                              <label className="cursor-pointer">
                                {(formData[doc] instanceof File &&
                                  formData[doc].type.includes("image/")) ||
                                isImage(
                                  documentPreviews[doc] || formData[doc]
                                ) ? (
                                  <img
                                    src={
                                      documentPreviews[doc] ||
                                      formatImageUrl(formData[doc])
                                    }
                                    alt={`${doc} Preview`}
                                    className="h-16 w-16 object-cover rounded-md border border-gray-300 dark:border-gray-600"
                                  />
                                ) : (
                                  <div className="h-16 w-16 flex items-center justify-center bg-gray-100 dark:bg-gray-700 rounded-md border border-gray-300 dark:border-gray-600">
                                    <FaFile className="text-2xl text-gray-400 dark:text-gray-500" />
                                  </div>
                                )}
                                <input
                                  type="file"
                                  className="hidden"
                                  onChange={(e) => handleFileChange(e, doc)}
                                  accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.csv,.zip,.rar"
                                />
                              </label>
                            </>
                          )}
                        </div>
                      ) : isActiveStatus ? (
                        <div className="h-16 w-16 flex items-center justify-center bg-gray-100 dark:bg-gray-700 rounded-md border-2 border-dashed border-gray-300 dark:border-gray-600">
                          <FaFile className="text-2xl text-gray-400 dark:text-gray-500" />
                          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                            No document
                          </p>
                        </div>
                      ) : (
                        <label className="flex flex-col items-center justify-center w-40 h-16 border-2 border-dashed border-gray-300 dark:border-gray-600 rounded-md cursor-pointer hover:border-[#1f4774] dark:hover:border-cyan-400 bg-white dark:bg-gray-800">
                          <div className="flex flex-col items-center justify-center pt-3 pb-4">
                            <FaUpload className="w-6 h-6 mb-2 text-gray-400 dark:text-gray-500" />
                            <p className="mb-1 text-xs text-gray-500 dark:text-gray-400">
                              Click to upload
                            </p>
                          </div>
                          <input
                            type="file"
                            className="hidden"
                            onChange={(e) => handleFileChange(e, doc)}
                            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.rtf,.csv,.zip,.rar"
                          />
                        </label>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className="mt-6 flex items-center gap-4">
                {isLoading ? (
                  <div className="h-11 w-40 bg-gray-300 dark:bg-gray-700 rounded-md animate-pulse flex items-center justify-center">
                    <div className="flex items-center space-x-2">
                      <div className="animate-spin rounded-full h-4 w-4 border-2 border-[#1f4774] dark:border-white border-t-transparent"></div>
                      <span className="text-gray-600 dark:text-gray-400 text-sm">Loading...</span>
                    </div>
                  </div>
                ) : (
  <button
                    type="submit"
                    disabled={isSubmitting || isLoading}
                    className="h-11 w-40 flex items-center justify-center rounded-md text-white font-medium bg-[#1C3664] hover:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed min-h-[44px] transition-colors duration-200 shadow-md"
                  >
                    {isSubmitting ? (
                      <div className="flex items-center justify-center space-x-2">
                        <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                        <span className="text-sm font-medium">
                          {!isActiveStatus ? "Saving..." : "Updating..."}
                        </span>
                      </div>
                    ) : !isActiveStatus ? (
                      <span className="text-sm font-medium">Save Instructor</span>
                    ) : (
                      <span className="text-sm font-medium">Update Instructor</span>
                    )}
                  </button>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
<style>{`
  /* Dark mode styling for ReactQuill toolbar icons */
  .ql-toolbar.ql-snow {
    ${isDarkMode ? `
      border-color: #4B5563 !important;
      background-color: #374151 !important;
    ` : ''}
  }
  
  .ql-toolbar.ql-snow .ql-stroke {
    ${isDarkMode ? `
      stroke: #FFFFFF !important;
    ` : ''}
  }
  
  .ql-toolbar.ql-snow .ql-fill {
    ${isDarkMode ? `
      fill: #FFFFFF !important;
    ` : ''}
  }
  
  .ql-toolbar.ql-snow .ql-picker-label {
    ${isDarkMode ? `
      color: #FFFFFF !important;
    ` : ''}
  }
  
  .ql-toolbar.ql-snow .ql-picker-options {
    ${isDarkMode ? `
      background-color: #374151 !important;
      border-color: #4B5563 !important;
      color: #FFFFFF !important;
    ` : ''}
  }
  
  .ql-toolbar.ql-snow button:hover,
  .ql-toolbar.ql-snow button:focus,
  .ql-toolbar.ql-snow .ql-picker-label:hover,
  .ql-toolbar.ql-snow .ql-picker-item:hover {
    ${isDarkMode ? `
      background-color: #4B5563 !important;
      color: #FFFFFF !important;
    ` : ''}
  }
  
  .ql-toolbar.ql-snow button:hover .ql-stroke,
  .ql-toolbar.ql-snow button:focus .ql-stroke {
    ${isDarkMode ? `
      stroke: #93C5FD !important;
    ` : ''}
  }
  
  .ql-toolbar.ql-snow button:hover .ql-fill,
  .ql-toolbar.ql-snow button:focus .ql-fill {
    ${isDarkMode ? `
      fill: #93C5FD !important;
    ` : ''}
  }
  
  .ql-container.ql-snow {
    ${isDarkMode ? `
      border-color: #4B5563 !important;
      background-color: #374151 !important;
    ` : ''}
  }

  /* MultiSelectDropdown Dark Mode Styling */
  .react-select__control {
    background-color: ${isDarkMode ? '#374151' : '#ffffff'} !important;
    border-color: ${isDarkMode ? '#4B5563' : '#D1D5DB'} !important;
    color: ${isDarkMode ? '#F3F4F6' : '#000000'} !important;
  }
  
  .react-select__single-value {
    color: ${isDarkMode ? '#F3F4F6' : '#000000'} !important;
  }
  
  .react-select__placeholder {
    color: ${isDarkMode ? '#9CA3AF' : '#6B7280'} !important;
  }
  
  .react-select__menu {
    background-color: ${isDarkMode ? '#374151' : '#ffffff'} !important;
    border: 1px solid ${isDarkMode ? '#4B5563' : '#D1D5DB'} !important;
    box-shadow: ${isDarkMode ? '0 4px 6px -1px rgba(0, 0, 0, 0.5)' : '0 4px 6px -1px rgba(0, 0, 0, 0.1)'} !important;
  }
  
  .react-select__option {
    background-color: ${isDarkMode ? '#374151' : '#ffffff'} !important;
    color: ${isDarkMode ? '#F3F4F6' : '#000000'} !important;
  }
  
  .react-select__option--is-focused {
    background-color: ${isDarkMode ? '#4B5563' : '#F3F4F6'} !important;
  }
  
  .react-select__option--is-selected {
    background-color: ${isDarkMode ? '#1E40AF' : '#3B82F6'} !important;
    color: #FFFFFF !important;
  }
  
  .react-select__input {
    color: ${isDarkMode ? '#F3F4F6' : '#000000'} !important;
  }
  
  .react-select__menu-list {
    background-color: ${isDarkMode ? '#374151' : '#ffffff'} !important;
  }
  
  .react-select__indicator {
    color: ${isDarkMode ? '#9CA3AF' : '#6B7280'} !important;
  }
  
  .react-select__indicator:hover {
    color: ${isDarkMode ? '#F3F4F6' : '#374151'} !important;
  }
  
  .react-select__multi-value {
    background-color: ${isDarkMode ? '#4B5563' : '#E5E7EB'} !important;
  }
  
  .react-select__multi-value__label {
    color: ${isDarkMode ? '#F3F4F6' : '#000000'} !important;
  }
  
  .react-select__multi-value__remove {
    color: ${isDarkMode ? '#9CA3AF' : '#6B7280'} !important;
  }
  
  .react-select__multi-value__remove:hover {
    background-color: #EF4444 !important;
    color: #FFFFFF !important;
  }

  /* Ensure dropdown text is visible */
  .react-select__option,
  .react-select__single-value,
  .react-select__placeholder,
  .react-select__input input {
    color: ${isDarkMode ? '#F3F4F6' : '#000000'} !important;
  }

  /* Scrollbar styling for dark mode */
  .react-select__menu-list::-webkit-scrollbar {
    width: 8px;
  }
  
  .react-select__menu-list::-webkit-scrollbar-track {
    background: ${isDarkMode ? '#374151' : '#f1f1f1'};
  }
  
  .react-select__menu-list::-webkit-scrollbar-thumb {
    background: ${isDarkMode ? '#6B7280' : '#888'};
    border-radius: 4px;
  }
  
  .react-select__menu-list::-webkit-scrollbar-thumb:hover {
    background: ${isDarkMode ? '#9CA3AF' : '#555'};
  }
`}</style>
    </div>
  );
};

export default EditInstructorForm;